{
  "version": 1,
  "asset_id": "6eae5e94-d301-4dd7-b216-d72cdf46107b",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/6eae5e94-d301-4dd7-b216-d72cdf46107b/stappenplan-aanleg-800.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/6eae5e94-d301-4dd7-b216-d72cdf46107b/stappenplan-aanleg-800.avif",
  "original_filename": "stappenplan-aanleg-800.avif",
  "size": 30501,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:34Z"
}
